export interface MenuOpcion {
  titulo: string
  descripcion: string
  clave: string
  icon: string
}
//Arreglo para mostrar opciones del menú
export const opcionesMenu: MenuOpcion[] = [
  {
    titulo: 'Contraseña',
    descripcion: 'Actualiza tu contraseña',
    clave: 'clave',
    icon: 'fa-solid fa-lock',
  },
]
